import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useThemeMode } from '../../ThemeContext';
import { dataAPI } from '../../helpers/api_service';
import SubscriptionPlans from './SubscriptionPlans';
import MySubscriptions from './MySubscriptions';
import './Subscription.css';

function Subscription() {
  const { mode } = useThemeMode();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [hasActiveSubscription, setHasActiveSubscription] = useState(false);
  
  // Check if we should force showing subscription plans
  const searchParams = new URLSearchParams(location.search);
  const forceShowPlans = searchParams.get('view') === 'plans';

  // Initialize theme on component mount
  useEffect(() => {
    document.body.classList.remove('dark-mode', 'light-mode');
    document.body.classList.add(mode === 'dark' ? 'dark-mode' : 'light-mode');
  }, [mode]);

  // Fetch subscription data on component mount
  useEffect(() => {
    const fetchSubscriptionData = async () => {
      try {
        setLoading(true);
        const response = await dataAPI.getMySubscription();
        
        console.log('=== MY SUBSCRIPTION API RESPONSE ===');
        console.log('Response:', response);
        
        if (response.status === 'success' && response.data) {
          setSubscriptionData(response.data);
          
          // Check if user has subscription history
          const hasHistory = response.data.subscription_history && 
                            Array.isArray(response.data.subscription_history) && 
                            response.data.subscription_history.length > 0;
          
          console.log('=== SUBSCRIPTION CHECK ===');
          console.log('Has subscription history:', hasHistory);
          console.log('Subscription history:', response.data.subscription_history);
          
          setHasActiveSubscription(hasHistory);
        } else {
          console.log('=== NO SUBSCRIPTION DATA ===');
          console.log('Response status:', response.status);
          setHasActiveSubscription(false);
        }
      } catch (err) {
        console.error('Error fetching subscription data:', err);
        // If API call fails, assume no subscription and show plans
        setHasActiveSubscription(false);
        setError(null); // Don't show error for this case
      } finally {
        setLoading(false);
      }
    };

    fetchSubscriptionData();
  }, []);

  if (loading) {
    return (
      <div className="subscription-page">
        <div className="text-center py-5">
          <h1 style={{ 
            color: mode === 'dark' ? '#FFFFFF' : '#333333',
            fontSize: '2rem',
            fontFamily: 'Urbanist, Arial, sans-serif',
            marginBottom: '1rem'
          }}>
            Loading...
          </h1>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="subscription-page">
        <div className="text-center py-5">
          <h1 style={{ 
            color: mode === 'dark' ? '#FFFFFF' : '#333333',
            fontSize: '2rem',
            fontFamily: 'Urbanist, Arial, sans-serif',
            marginBottom: '1rem'
          }}>
            Error loading subscription data
          </h1>
          <p style={{ 
            color: mode === 'dark' ? '#a0a0a0' : '#666666',
            fontSize: '1rem',
            fontFamily: 'Urbanist, Arial, sans-serif'
          }}>
            Please try again later.
          </p>
        </div>
      </div>
    );
  }

  // Conditional rendering based on subscription status and URL params
  if (forceShowPlans) {
    console.log('=== FORCING SUBSCRIPTION PLANS (from URL param) ===');
    return <SubscriptionPlans />;
  } else if (hasActiveSubscription) {
    console.log('=== RENDERING MY SUBSCRIPTIONS ===');
    console.log('Subscription data:', subscriptionData);
    return <MySubscriptions subscriptionData={subscriptionData} />;
  } else {
    console.log('=== RENDERING SUBSCRIPTION PLANS ===');
    return <SubscriptionPlans />;
  }
}

export default Subscription;
